import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField, Typography } from '@mui/material';
import api from '../api/client';
export default function AccountAccessControls({ account, onChanged }) {
  const [open, setOpen] = useState(false), [role, setRole] = useState(account.role), [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false), [message, setMessage] = useState(null);
  const owner = JSON.parse(localStorage.getItem('rv_user') || 'null');
  function close() { if (!busy) { setOpen(false); setPassword(''); setMessage(null); } }
  async function save(kind) {
    if (busy) return; setBusy(true); setMessage(null);
    const token = localStorage.getItem('rv_token');
    try {
      if (kind === 'role') await api.put(`/users/${account.id}/role`, { role }, { expectedSessionToken: token });
      else await api.post(`/users/${account.id}/temporary-password`, { temporaryPassword: password }, { expectedSessionToken: token });
      setPassword(''); setMessage({ severity: 'success', text: kind === 'role' ? 'Role updated. Existing sessions were revoked.' : 'Temporary password set. The user must sign in again and choose a new password.' });
      onChanged?.();
    } catch (error) { const body = error.response?.data; setMessage({ severity: 'error', text: typeof body === 'string' ? body : body?.message || 'The account change could not be saved.' }); }
    finally { setBusy(false); }
  }
  return <>
    <Button size="small" variant="outlined" onClick={() => { setRole(account.role); setMessage(null); setOpen(true); }}>Role / password</Button>
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>Account access: {account.username}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {message && <Alert severity={message.severity}>{message.text}</Alert>}
          <TextField select label="Role" value={role === 'user' ? 'ranger' : role} disabled={busy || owner?.id === account.id} onChange={e => setRole(e.target.value)}>
            <MenuItem value="ranger">User / Ranger</MenuItem><MenuItem value="supervisor">Supervisor</MenuItem><MenuItem value="admin">Admin</MenuItem>
          </TextField>
          <Button variant="contained" disabled={busy || role === account.role || owner?.id === account.id} onClick={() => save('role')}>Save role</Button>
          <Typography variant="body2">Set a temporary password to reset access. This ends existing sessions and requires a different password at the next login. Disabled accounts stay disabled until you enable them.</Typography>
          <TextField label="Temporary password" type="password" autoComplete="new-password" value={password} disabled={busy} onChange={e => setPassword(e.target.value)} helperText="At least 8 characters: uppercase, lowercase, number and symbol. Maximum 72 UTF-8 bytes." />
          <Button variant="outlined" disabled={busy || !password} onClick={() => save('password')}>Set temporary password</Button>
        </Stack>
      </DialogContent>
      <DialogActions><Button disabled={busy} onClick={close}>Close</Button></DialogActions>
    </Dialog>
  </>;
}
